/**
 * Wo der Wortlaut der Oberfläche herkommt.
 *
 * **Der Text steht in `de.ts`, der Zugriff hier** — und diese Trennung ist die
 * ganze Vorbereitung auf eine zweite Sprache. Aus dem Betrieb: „Vorbereiten
 * für Mehrsprachigkeit. Aber noch nicht umsetzen."
 *
 * **Komponenten rufen `useTexte()`**, nie `de` unmittelbar. Heute gibt der
 * Haken schlicht das deutsche Objekt zurück; käme eine zweite Sprache dazu,
 * läse er sie aus einem Context, und **geändert würde genau diese eine
 * Datei** statt dreißig Komponenten. Dass es ein Haken ist und keine
 * Konstante, ist deshalb kein Umstand ohne Grund: eine Sprachwahl muss die
 * Oberfläche neu zeichnen können.
 *
 * `tools/pruefstand/texte.ts` hält beides fest — kein toter Schlüssel, kein
 * deutscher Satz zurück im JSX, und kein Import an dieser Stelle vorbei.
 */
import { de } from './de'

/**
 * Die Form des Wortlauts.
 *
 * Eine zweite Sprache wäre eine Datei, die diesen Typ erfüllt — und der
 * Übersetzer zählte die fehlenden Sätze ab, statt sie im Betrieb fehlen zu
 * lassen.
 */
export type Texte = typeof de

export function useTexte(): Texte {
  return de
}

/**
 * Derselbe Wortlaut für Stellen ohne Komponente.
 *
 * **Ein Haken geht nur in einer Komponente**, und ein paar Hilfsfunktionen
 * stehen daneben — `nenne()` und `anzeigeArt()` in der Diagnose etwa. Für sie
 * gibt es diesen Ausgang, und er ist ausdrücklich der Ausgang und nicht der
 * Weg: **wer ihn in einer Komponente benutzt, umgeht die Sprachwahl**, die
 * später hier hängt, und merkt es erst, wenn er sie baut.
 *
 * `tools/pruefstand/texte.ts` führt deshalb Buch darüber, wo er benutzt wird.
 */
export const WORTLAUT: Texte = de
